"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PimDetailsPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_2 = require("@nextui-org/react");
var doshx_controls_web_1 = require("doshx_controls_web");
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var get_product_1 = require("../../../../../api/calls/product/get_product");
var get_product_completeness_1 = require("../../../../../api/calls/product/get_product_completeness");
var update_product_1 = require("../../../../../api/calls/product/update_product");
var upgradeModalComponent_1 = require("../../../../../components/upgradeModalComponent");
var constants_1 = require("../../../../../constants/constants");
var routes_1 = require("../../../../../constants/routes");
var sanitiseObject_1 = require("../../../../../helpers/sanitiseObject");
var category_1 = require("../../../../../reducers/slices/categories/category");
var console_1 = require("../../../../../reducers/slices/console");
var main_1 = require("../../../../../reducers/slices/main");
var get_category_thunk_1 = require("../../../../../reducers/slices/products/categories/thunks/get_category_thunk");
var product_1 = require("../../../../../reducers/slices/products/product");
var get_product_types_thunk_1 = require("../../../../../reducers/slices/products/product_types/thunks/get_product_types_thunk");
var add_product_thunk_1 = require("../../../../../reducers/slices/products/thunks/add_product_thunk");
var get_client_tags_thunk_1 = require("../../../../../reducers/slices/products/thunks/get_client_tags_thunk");
var get_products_shopify_thunk_1 = require("../../../../../reducers/slices/products/thunks/get_products_shopify_thunk");
var client_user_selector_1 = require("../../../../../selectors/client_user_selector");
var linked_marketplaces_1 = __importDefault(require("../components/marketplace/linked_marketplaces"));
var pim_add_tags_1 = __importDefault(require("./components/pim_add_tags"));
var pim_addons_component_1 = __importDefault(require("./components/pim_addons_component"));
var pim_build_variations_component_1 = require("./components/pim_build_variations_component");
var pim_channels_and_apps_1 = __importDefault(require("./components/pim_channels_and_apps"));
var pim_condiment_groups_component_1 = __importDefault(require("./components/pim_condiment_groups_component"));
var pim_connected_channels_1 = __importDefault(require("./components/pim_connected_channels"));
var pim_details_component_1 = __importDefault(require("./components/pim_details_component"));
var pim_image_component_1 = require("./components/pim_image_component");
var pim_product_attribute_component_1 = __importDefault(require("./components/pim_product_attribute_component/pim_product_attribute_component"));
var pim_product_completeness_1 = __importDefault(require("./components/pim_product_completeness"));
var pim_promotion_component_1 = require("./components/pim_promotion_component");
var pim_review_supplier_product_component_1 = __importDefault(require("./components/pim_review_supplier_product_component"));
var pim_variance_config_1 = __importDefault(require("./components/pim_variance_config"));
var constants_2 = require("./constants");
var pim_product_additional_details_1 = __importDefault(require("./components/pim_product_additional_details"));
var price_sequencer_1 = __importDefault(require("../components/product_details/price_sequencer"));
var PimDetailsPage = function () {
    var _a;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.categoryState; }), pagination = _b.pagination, loaded = _b.loaded;
    var _c = (0, react_redux_1.useSelector)(function (state) { return state.userState; }), client_token = _c.client_token, user = _c.user;
    var _d = (0, react_redux_1.useSelector)(client_user_selector_1.clientSubsciptionStatusSelector), isUnsubscribed = _d.isUnsubscribed, isFreemiumPlan = _d.isFreemiumPlan;
    var _e = (0, react_redux_1.useSelector)(function (state) { return state.productState; }), products = _e.products, productsPagination = _e.pagination, loading = _e.loading;
    var _f = (0, react_1.useState)(), completeness = _f[0], setCompleteness = _f[1];
    var _g = (0, react_1.useState)(), requiredFields = _g[0], setRequiredFields = _g[1];
    var _h = (0, react_1.useState)(false), canPublish = _h[0], setCanPublish = _h[1];
    var _j = (0, react_router_dom_1.useParams)(), product_id = _j.product_id, supplier_id = _j.supplier_id;
    var _k = (0, react_1.useState)(constants_2.initialProductValues), values = _k[0], setValues = _k[1];
    var _showUpgradeModal = function (_) {
        return dispatch((0, main_1.setContentModal)({
            title: constants_1.UPGRADE_MODAL_TITLE,
            content: ((0, jsx_runtime_1.jsx)(upgradeModalComponent_1.UpgradeModalComponent, { message: "Whoa there, superstar! You've maxed out at 10 products on your current plan. Want to move more merch? Time to level up! Upgrade now and transform your store from cozy boutique to mega-mart." })),
        }));
    };
    var location = (0, react_router_dom_1.useLocation)();
    var state = location.state;
    var productLimitReached = products.length >= Number(process.env.FREEMIUM_PRODUCT_LIMIT);
    var addProduct = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var payload, _a, success, product;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if ((isUnsubscribed || isFreemiumPlan) && productLimitReached) {
                        return [2 /*return*/, _showUpgradeModal(null)];
                    }
                    return [4 /*yield*/, dispatch((0, add_product_thunk_1.add_product_thunk)(params))];
                case 1:
                    payload = (_b.sent()).payload;
                    _a = payload || {}, success = _a.success, product = _a.content;
                    if (!success) return [3 /*break*/, 3];
                    return [4 /*yield*/, fetchCompleteness(product._id)];
                case 2:
                    _b.sent();
                    return [2 /*return*/, canPublish && navigate(-1)];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getSelectedProduct = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, get_product_1.get_product)({ _id: product_id })];
                case 1:
                    response = _a.sent();
                    if (response.success) {
                        setValues(response.content);
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when retrieving the selected product.", messages: [response.message] }));
                        setTimeout(function () {
                            navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.PRODUCT_LIST_ROUTE));
                        }, 2000);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getProductTypes = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch((0, get_product_types_thunk_1.get_product_types_thunk)(""))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var updateValues = function (prop, value) {
        var _a;
        setValues(__assign(__assign({}, values), (_a = {}, _a[prop] = value, _a)));
    };
    var onSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var params, transformedCondiments, response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    values.variations = [];
                    if ((user === null || user === void 0 ? void 0 : user.role) !== "ADMIN") {
                        values.availability = "OFFLINE";
                        values.branch_id_list = user === null || user === void 0 ? void 0 : user.manager_of;
                    }
                    params = (0, sanitiseObject_1.sanitiseObject)(__assign({}, values));
                    if (!!values._id) return [3 /*break*/, 2];
                    return [4 /*yield*/, addProduct(params)];
                case 1:
                    _b.sent();
                    return [3 /*break*/, 5];
                case 2:
                    transformedCondiments = (_a = params === null || params === void 0 ? void 0 : params.condiments) === null || _a === void 0 ? void 0 : _a.map(function (condiment) {
                        var defaultProduct = condiment.product_list.find(function (product) { return product.default; });
                        var requiredProducts = condiment.product_list.filter(function (product) { return product.required; }).map(function (product) { return product._id; });
                        return {
                            condiment_id: condiment._id,
                            default_product_id: defaultProduct ? defaultProduct._id : null,
                            required_products: requiredProducts,
                        };
                    });
                    params.condiments = transformedCondiments;
                    dispatch((0, product_1.setLoading)(true));
                    return [4 /*yield*/, (0, update_product_1.update_product)(params)];
                case 3:
                    response = _b.sent();
                    return [4 /*yield*/, fetchCompleteness()];
                case 4:
                    _b.sent();
                    dispatch((0, product_1.setLoading)(false));
                    if (response.success) {
                        dispatch((0, main_1.setMessageModal)({ title: "Success...", messages: [response.message] }));
                    }
                    else {
                        dispatch((0, main_1.setMessageModal)({ title: "Something went wrong when updating product details!", messages: [response.message] }));
                    }
                    _b.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var enableSaveButton = false;
    enableSaveButton = [values === null || values === void 0 ? void 0 : values.status, values === null || values === void 0 ? void 0 : values.title, values === null || values === void 0 ? void 0 : values.pid, values === null || values === void 0 ? void 0 : values.sku].every(function (field) { return (field === null || field === void 0 ? void 0 : field.length) > 0; });
    if (values === null || values === void 0 ? void 0 : values.attributes) {
        enableSaveButton = (_a = values === null || values === void 0 ? void 0 : values.attributes) === null || _a === void 0 ? void 0 : _a.length;
    }
    var renderSaveButton = ((0, jsx_runtime_1.jsx)(react_2.Button, __assign({ isLoading: loading, startContent: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCloud }), color: "primary", variant: "solid", 
        //  isDisabled={!enableSaveButton}
        onClick: onSave }, { children: product_id ? "Update" : canPublish ? "Save" : "Save as draft" })));
    var fetchCompleteness = function (productId) {
        if (productId === void 0) { productId = product_id; }
        return __awaiter(void 0, void 0, void 0, function () {
            var response, _a, status_1, completeness_1, required_fields, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!productId)
                            return [2 /*return*/];
                        (0, product_1.setLoading)(true);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, (0, get_product_completeness_1.get_product_completeness)({ _id: productId })];
                    case 2:
                        response = _b.sent();
                        if (response.success) {
                            _a = response.content, status_1 = _a.status, completeness_1 = _a.completeness, required_fields = _a.required_fields;
                            setCompleteness(completeness_1);
                            setRequiredFields(required_fields);
                            setCanPublish(status_1 === "complete");
                        }
                        else {
                            throw new response.message();
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _b.sent();
                        dispatch((0, main_1.setMessageModal)({
                            title: "Something went wrong when retrieving the product completeness.",
                            messages: ["Failed to fetch product completeness."],
                        }));
                        return [3 /*break*/, 5];
                    case 4:
                        (0, product_1.setLoading)(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    (0, react_1.useEffect)(function () {
        if (!loaded && client_token) {
            dispatch((0, category_1.setLoaded)(true));
            dispatch((0, get_category_thunk_1.get_category_thunk)(__assign({}, pagination)));
            dispatch((0, get_client_tags_thunk_1.get_client_tags_thunk)({}));
        }
    }, [client_token]);
    (0, react_1.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Product Details"));
        if (product_id && client_token) {
            getSelectedProduct();
        }
        if (client_token) {
            dispatch((0, get_products_shopify_thunk_1.get_products_thunk)(__assign({}, productsPagination)));
            fetchCompleteness();
            getProductTypes();
        }
    }, [client_token, product_id]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-2 mb-6" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "flex justify-between items-center gap-4" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-row mb-4" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.ButtonControl, { iconColor: "text-black", label: "Back To Products", size: "xsmall", startIcon: pro_light_svg_icons_1.faChevronLeft, backgroundColor: "bg-transparent", textColor: "text-black", onClick: function () {
                            navigate("".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.PIM_ROUTE));
                        } }) })) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "grid grid-cols-2 gap-6" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsx)(pim_details_component_1.default, { values: values, updateValues: updateValues, saveButton: renderSaveButton }), (0, jsx_runtime_1.jsx)(pim_product_additional_details_1.default, { values: values, updateValues: updateValues, saveButton: renderSaveButton }), (0, jsx_runtime_1.jsx)(pim_addons_component_1.default, { values: values, setValues: setValues }), (0, jsx_runtime_1.jsx)(pim_product_attribute_component_1.default, { values: values, setValues: setValues, saveButton: renderSaveButton }), (0, jsx_runtime_1.jsx)(pim_condiment_groups_component_1.default, { values: values, setValues: setValues }), (0, jsx_runtime_1.jsx)(pim_promotion_component_1.PimPromotionComponent, { values: values, setValues: setValues, updateValues: updateValues }), (0, jsx_runtime_1.jsx)(pim_build_variations_component_1.PimBuildVariationsComponent, { values: values, setValues: setValues, updateValues: updateValues, product_id: product_id })] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex-1 flex flex-col gap-4" }, { children: [supplier_id && (0, jsx_runtime_1.jsx)(pim_review_supplier_product_component_1.default, { values: values, supplier_id: supplier_id, markup_price: state === null || state === void 0 ? void 0 : state.markup_price }), (0, jsx_runtime_1.jsx)(pim_product_completeness_1.default, { productId: product_id, refreshCompleteness: fetchCompleteness, completeness: completeness, requiredFields: requiredFields }), (0, jsx_runtime_1.jsx)(pim_image_component_1.PimImageComponent, { values: values, setValues: setValues, updateValues: updateValues }), (0, jsx_runtime_1.jsx)(pim_variance_config_1.default, { values: values, setValues: setValues, updateValues: updateValues }), (0, jsx_runtime_1.jsx)(pim_connected_channels_1.default, { values: values, updateValues: updateValues }), (0, jsx_runtime_1.jsx)(pim_channels_and_apps_1.default, { canPublish: canPublish, values: values, setValues: setValues, updateValues: updateValues }), (0, jsx_runtime_1.jsx)(pim_add_tags_1.default, { values: values, setValues: setValues }), (0, jsx_runtime_1.jsx)(linked_marketplaces_1.default, { product_id: product_id, product_price: values === null || values === void 0 ? void 0 : values.price }), (0, jsx_runtime_1.jsx)(price_sequencer_1.default, { values: values, setValues: setValues, saveButton: renderSaveButton })] }))] }))] })));
};
exports.PimDetailsPage = PimDetailsPage;
